module.exports = __webpack_public_path__ + "media/images/icons/logo-short-b5ac55713a341f6b8ea51307e896b7c3.svg";